import { useState, useEffect } from "react";

const useCheckScreenSize = (breakpoint) => {
  // Guard against non-browser environments like server-side rendering
  const isBrowser = typeof window !== "undefined";

  // Set initial value based on actual screen width if in a browser environment
  const initialSize = isBrowser ? window.innerWidth <= breakpoint : false;

  const [isMobile, setIsMobile] = useState(initialSize);

  useEffect(() => {
    if (!isBrowser) return; // Exit early if not in a browser environment

    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= breakpoint);
    };

    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, [breakpoint, isBrowser]);

  return isMobile;
};

export { useCheckScreenSize };
